import { Button, Modal, Popover, Row, Tooltip } from "antd";
import { useState } from "react";
import { useUpdateRatingNegotiationMutation } from "../redux/api/negotiationsApiSlice";
import { useParams } from "react-router-dom";
import ReactMarkdown from "react-markdown";

export default function RaterButton({ callbackSaveData }: { callbackSaveData: () => void }) {
  const { id } = useParams()

  const [triggerRater, { isLoading }] = useUpdateRatingNegotiationMutation()

  const [popoverOpen, setPopoverOpen] = useState<boolean>(false)
  const [errorModalOpen, setErrorModalOpen] = useState<boolean>(false)
  const [errorMessage, setErrorMessage] = useState<string>("")

  const getRaterData = () => {
    if (id) {
      setPopoverOpen(false)
      triggerRater(id).unwrap()
        .then(() => {
          callbackSaveData()
        })
        .catch(err => {
          setErrorMessage(err)
          setErrorModalOpen(true)
        })
    }
  }

  const popoverContent = () => {
    return <div>
      Continuando con l'operazione i dati attualmente presenti verranno sovrascritti. <br />
      Si desidera continuare?

      <Row justify={"end"} style={{ marginTop: "1rem" }}>
        <Button size={"small"} type={"primary"} onClick={() => getRaterData()}>
          Richiama dati da rater
        </Button>
      </Row>
    </div>
  }

  const modalFooter = () => {
    return <div>
      <Button onClick={() => setErrorModalOpen(false)}>Chiudi</Button>
    </div>
  }

  return <>
    <Tooltip placement="top" title="Richiama rater">
      <Popover
        trigger={"click"}
        open={popoverOpen}
        placement={"top"}
        title={"Attenzione"}
        content={popoverContent}
        onOpenChange={open => setPopoverOpen(open)}>
        <Button
          loading={isLoading}
          type={"primary"}
        >
          Applica premio e quotazione Fast Quotation
        </Button>
      </Popover>
    </Tooltip>
    <Modal footer={modalFooter()} open={errorModalOpen} title={"Impossibile richiamare il rater"} onCancel={() => setErrorModalOpen(false)}>
      <ReactMarkdown>{errorMessage}</ReactMarkdown>
    </Modal>
  </>
}
